import cn from "classnames"
import React, { useId } from "react"
import { type UseFormRegisterReturn } from "react-hook-form"
import { mergeRefs } from "../util/react"

export interface CheckboxProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  groupId?: string
  registerFields?: UseFormRegisterReturn
  label?: string | React.ReactNode
  help?: React.ReactNode
  className?: string
  inputClassName?: string
  error?: string | React.ReactNode
  skeleton?: boolean
  labelClassName?: string
}

const ForwardableCheckbox: React.ForwardRefRenderFunction<HTMLInputElement, CheckboxProps> = (
  {
    label,
    groupId,
    children,
    registerFields,
    className,
    inputClassName,
    labelClassName,
    error,
    skeleton,
    help,
    ...props
  },
  ref
) => {
  const defaultId = useId()
  props.id = props.id || defaultId

  return (
    <div className={cn("relative", { "has-error has-feedback": error }, className)} id={groupId}>
      <div className="checkbox !mb-0 !py-0">
        <input
          type="checkbox"
          className={cn("form-control", inputClassName)}
          {...registerFields}
          {...props}
          ref={mergeRefs(ref, registerFields?.ref)}
        />
        {label && (
          <label htmlFor={props.id} className={cn("checkbox-label paragraph-xs", { skeleton }, labelClassName)}>
            {label}
          </label>
        )}
      </div>
      {error && <p className="field_error text-error">{error}</p>}
      {children}
    </div>
  )
}

const Checkbox = React.forwardRef(ForwardableCheckbox)

export default Checkbox
